import { render } from "./StoresTotalRevenue.vue?vue&type=template&id=3b20b832"
import script from "./StoresTotalRevenue.vue?vue&type=script&lang=js"
export * from "./StoresTotalRevenue.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__